import { addCurrentOpenings } from 'pages/TrackAndTrace/ContainerDetail/utils/transform-containers';
import * as React from 'react';
import { useQuery } from '@tanstack/react-query';
import { fetchTerminals } from 'services/clients/terminal';
import { getCurrentShift } from 'services/helpers/shift';
import { Container, LegacyContainerStatus } from 'types/Watchlist';
import { ReturnAppointmentsContext } from '../../context';
import { Cell } from '../Cell';
import { EmptyCell } from '../EmptyCell';
import { CellProps } from '../types';
import { TerminalIcon } from './TerminalIcon';

export const EmptyReturnLocationCell: React.FC<CellProps> = (props) => {
  const { shift: currentShiftId, day: currentDate } = getCurrentShift();
  const terminalsQuery = useQuery(
    ['terminals', 'TrackNTrace'],
    ({ signal }) => fetchTerminals({ signal, onlyTrackAndTrace: true }),
    {
      staleTime: Infinity,
      cacheTime: Infinity,
    }
  );

  const container: Container = props.row;
  const { status, gatedIn } = container;
  const { terminalStatuses } = React.useContext(ReturnAppointmentsContext);

  const currentOpenings = addCurrentOpenings(
    container,
    currentDate,
    currentShiftId,
    terminalStatuses
  );

  if (
    currentOpenings.length === 0 ||
    gatedIn ||
    status === LegacyContainerStatus.Import ||
    status === LegacyContainerStatus.OnVessel
  ) {
    return <EmptyCell />;
  }

  return (
    <Cell className="space-x-2 text-center flex items-start">
      {currentOpenings.map((opening) => {
        const terminal = terminalsQuery.data?.find((t) => t.key === opening.terminalId);
        return (
          <div
            key={opening.terminalId}
            className="flex flex-col space-y-2 text-center items-center"
          >
            <div className="flex space-x-2 items-center">
              <div className="w-4 h-4">
                <TerminalIcon opening={opening} terminal={terminal} />
              </div>
              <h5 className="text-gray-800 font-semibold">{opening.terminalName}</h5>
            </div>
            <div className="flex items-center">
              {opening.availabilityId === 'dual' && (
                <h6 className="uppercase font-medium text-gray-700">
                  dual &nbsp;
                  <span className={`${opening.chassisRestrictions.length <= 0 && 'hidden'}`}>
                    ·
                  </span>
                </h6>
              )}
              {opening.chassisRestrictions.map((restriction: string, index: number) => {
                return (
                  // eslint-disable-next-line react/no-array-index-key
                  <div key={index} className="flex items-center">
                    <h6 className="uppercase font-medium text-gray-700">
                      &nbsp;{restriction} &nbsp;
                      <span className={`${index === restriction.length - 1 && 'hidden'}`}>
                        · &nbsp;
                      </span>
                    </h6>
                  </div>
                );
              })}
            </div>
          </div>
        );
      })}
    </Cell>
  );
};
EmptyReturnLocationCell.displayName = 'ContainerTable.EmptyReturnLocationCell';
